import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { Endpoint } from '@/store/modules/endpoint/endpointTypes'

interface EndpointsComposable {
  getEndpoints: (entityType: string | number) => Endpoint
}

export default function useEndpoints(): EndpointsComposable {
  const endpointModule = ModuleNamespaces.ENDPOINT

  const getEndpoints = (entityType: string | number): Endpoint => {
    return store.getters[`${endpointModule}/getEndpoints`](entityType)
  }

  return {
    getEndpoints
  }
}
